<template>
    <section>
        <div>
            <h1>Products and Resources</h1>
        </div>
        <div>
            <v-carousel cycle height="400" hide-delimiters>
            <v-carousel-item v-for="(card, index) in cards" :key="index">
                <v-card class="mx-auto" max-width="400">
                    <v-img class="align-end text-white" height="200" :src="getImageSrc(card.images[0])" cover>
                        <v-card-title>{{ card.title }}</v-card-title>
                    </v-img>
                <v-card-subtitle class="pt-4">
                    {{ card.subtitle }}
                </v-card-subtitle>
                <v-card-text>
                    <div>{{ card.description }}</div>
                    <div>{{ card.additionalInfo }}</div>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="orange"> PDF </v-btn>
                    <v-spacer></v-spacer>
                    <router-link to="/noticiadetalle">
                        <v-btn color="blue"> Details </v-btn>
                    </router-link>
                </v-card-actions>
                </v-card>
            </v-carousel-item>
            </v-carousel>
        </div>
        <v-row>
            <v-col v-for="card in cards" :key="card.id" cols="12" md="4">
                <v-card class="mx-auto" max-width="400">
                    <!-- Carrusel de imágenes -->
                    <v-carousel cycle height="200" hide-delimiters>
                    <v-carousel-item v-for="(image, index) in card.images" :key="index">
                        <!-- Ajusta las clases para controlar el tamaño y el ajuste de la imagen -->
                        <v-img class="align-end text-white" height="100%" :src="require(`../assets/${image}`)" contain></v-img>
                    </v-carousel-item>
                    </v-carousel>
                    <v-divider class="mx-2 mb-1"></v-divider>
                    <v-card-title>{{ card.title }}</v-card-title>
                    <v-card-subtitle><b>{{ card.subtitle }}</b></v-card-subtitle>
                    <v-divider class="mx-4 mb-1"></v-divider>
                    <v-card-text>
                        <div>{{ card.description }}</div>
                        <div>{{ card.additionalInfo }}</div>
                    </v-card-text>
                    <div>
                    <v-chip-group>
                        <v-chip v-for="(time, index) in card.chip" :key="index">{{ time }}</v-chip>
                    </v-chip-group>
                    </div>
                    <v-card-actions>
                        <v-btn color="orange"> PDF </v-btn>
                        <v-spacer></v-spacer>
                        <router-link to="/noticiadetalle">
                            <v-btn color="blue"> Details </v-btn>
                        </router-link>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </section>
</template>

<script>
export default {
    data() {
        return {
            cards: [
                {
                    id: 1,
                    title: 'Corruption',
                    subtitle: 'UNODC',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 1',
                    images: ['logo2.png', 'logo.png'],                    
                    chip: ['8:00 AM', '10:00 AM', '2:00 PM', '4:00 PM'], 
                },
                {
                    id: 2,
                    title: 'Projust',
                    subtitle: 'UNODC-Colombia',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 2',
                    images: ['logo.png', 'logo2.png'],                    
                    chip: ['7:00 AM', '9:00 AM', '11:00 AM'], 
                },
                {
                    id: 3,
                    title: 'Projust',
                    subtitle: 'UNODC-Colombia',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 2',
                    images: ['logo.png', 'logo2.png'],
                    chip: ['7:00 AM', '9:00 AM'], 
                },
            ],
        };  
    },
    methods: {
        getImageSrc(filename) {
            return require(`../assets/${filename}`);
        },
    },
};
</script>